import useOrdersState from 'state/useOrdersState';
import useServiceState from 'state/useServicesState';
import useStorageState from 'state/useStorageState';

const useResetData = () => {
  const {
    resetDataWithoutLoaders: resetOrderDataState,
    setResetDataWithoutLoaders: setResetOrderData,
    resetDataWithLoaders: resetOrderDataWithLoadersState,
    setResetDataWithLoaders: setResetOrderDataWithLoaders
  } = useOrdersState();
  const {
    resetDataWithoutLoader: resetLSDataState,
    setResetDataWithoutLoader: setResetLSData,
    resetDataInLSDetails: resetLSDataWithLoadersState,
    setResetDataInLSDetails: setResetLSDataWithLoaders
  } = useServiceState();
  const {
    resetDataWithLoaders: resetStorageDataWithLoadersState,
    setResetDataWithLoaders: setResetStorageDataWithLoaders
  } = useStorageState();

  const resetOrderData = () => {
    setResetOrderData(!resetOrderDataState);
  };

  const resetLSData = () => {
    setResetLSData(!resetLSDataState);
  };

  const resetOrderDataWithLoaders = () => {
    setResetOrderDataWithLoaders(!resetOrderDataWithLoadersState);
  };

  const resetLSDataWithLoaders = () => {
    setResetLSDataWithLoaders(!resetLSDataWithLoadersState);
  };

  const resetStorageDataWithLoaders = () => {
    setResetStorageDataWithLoaders(!resetStorageDataWithLoadersState);
  };

  return {
    resetOrderData,
    resetLSData,
    resetOrderDataState,
    resetLSDataState,
    resetOrderDataWithLoadersState,
    resetLSDataWithLoadersState,
    resetStorageDataWithLoadersState,
    resetOrderDataWithLoaders,
    resetLSDataWithLoaders,
    resetStorageDataWithLoaders
  };
};

export default useResetData;
